import { useLocation, useResolvedPath } from 'react-router'

export const useCheckPathSelected = (path: string) => {
  const location = useLocation()
  const pathLocation = useResolvedPath(path)

  return _.startsWith(location.pathname, pathLocation.pathname)
}
